import React, { useEffect, useState } from 'react';
import CustomToggle from '../CustomToggle';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import { useTranslation } from 'react-i18next';
import Icon from '../shared/Icon';
import { exportTableToCsv } from '../../utils/tables';
import { useTheme } from '../../hooks/useTheme';
import IconButton from '../shared/IconButton';
import { InputAdornment, TextField } from '@mui/material';

interface TableOptionBarProps {
    searchTableId?: string;
    title?: string;
    children?: React.ReactNode;
    exportTableId?: string;
    exportTableName?: string;
    style?: React.CSSProperties;
    showSearch?: boolean;
    showExport?: boolean;
    leftComponent?: React.ReactNode;
    onSearchChange?: (text: string) => void;
    searchValue?: string;
}

const TableOptionBar: React.FC<TableOptionBarProps> = ({
    searchTableId = 'fu-planning-obj',
    children,
    title,
    exportTableId = 'csv-planning-obj',
    exportTableName = 'file',
    style,
    showSearch = true,
    showExport = true,
    leftComponent,
    searchValue,
    onSearchChange = () => {},
}) => {
    const { t } = useTranslation();
    const { muiTheme } = useTheme();

    return (
        <div
            className="fx-r min-h-40px pad-10px  fx-w w-100" 
            style={{ borderBottom: 1, borderColor: muiTheme.palette.divider, borderBottomStyle: 'solid', ...style }}
        >
            <div className="fx-r fx-items-c gap-5px min-w-300 " style={{ flex: 1 }}>
                {showSearch && (
                    <TextField
                        value={searchValue}
                        onChange={(event) => {
                            onSearchChange(event.target.value);
                        }}
                        variant="outlined"
                        placeholder={capitalizeFirstLetter(t('search')) + '...'}
                        sx={{ width: 300 }}
                        size="small"
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Icon name="search" fontSize="small" />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {searchValue ? (
                                            <IconButton
                                                iconName="close"
                                                size="small"
                                                onClick={() => {
                                                    onSearchChange('');
                                                }}
                                                iconProps={{ fontSize: 'small' }}
                                            />
                                        ) : null}
                                    </InputAdornment>
                                ),
                            },
                        }}
                    />
                )}

                {leftComponent}
            </div>
            <div className="fx-r  fx-justify-c font-w-700" style={{ flex: 1 }}>
                {title}
            </div>
            <div className="fx-r   fx-items-c fx-justify-fe gap-20px" style={{ flex: 1 }}>
                {children}
                {showExport && (
                    <IconButton
                        iconName="fileDownload"
                        onClick={() => exportTableToCsv(exportTableId, exportTableName)}
                        title={capitalizeFirstLetter(t('exportTableAsCsv'))}
                    />
                )}
            </div>
        </div>
    );
};

export default TableOptionBar;
